module.exports = __webpack_public_path__ + "static/img/rage_strike-market@2x.73350cd9.png";